import { useCallback } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';

const messages = defineMessages({
	isRequiredError: {
		id: 'jira.jira.jira-platform-fields.is-required-error',
		defaultMessage: '{fieldName} is required',
		description: 'Label for the error message when a field is required',
	},
	errorLabel: {
		id: 'jira.jira.jira-platform-fields.validation-popup.error-label',
		defaultMessage: 'Error',
		description: 'Label shown for the validation message error icon.',
	},
});

export const useValidateRequiredField = ({
	isRequired,
	isEditable,
	fieldName,
	fieldTypeForAnalytics,
}: {
	fieldName?: string;
	fieldTypeForAnalytics: string;
	isEditable: boolean;
	isRequired: boolean;
}): ((value: unknown) => string | undefined) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formatMessage } = useIntl();

	return useCallback(
		(value: unknown) => {
			const isEmpty =
				value == null ||
				(typeof value === 'string' && value.trim() === '') ||
				(Array.isArray(value) && value.length === 0);

			if (isEmpty && isRequired) {
				fireUIAnalytics(
					createAnalyticsEvent({
						action: 'validationError',
						actionSubject: 'inlineEdit',
					}),
					{
						fieldName,
						fieldType: fieldTypeForAnalytics,
						isRequired,
						isEditable,
					},
				);
				return formatMessage(messages.isRequiredError, {
					fieldName,
				});
			}
			return undefined;
		},
		[isRequired, formatMessage, fieldName, createAnalyticsEvent, isEditable, fieldTypeForAnalytics],
	);
};
